import React, { Component } from 'react';
import '../Autocomplete.css';

class Autocomplete extends Component {
  render() {
    return <div className="Autocomplete">
      <span className="matching">doc</span>
      <span className="preview">ument</span>
    </div>;
  }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js